import H1 from './H1.png'
import H10 from './H10.jpg'
import H11 from './H11.webp'
import H2 from './H2.png'
import H20 from './MAS Logo.png'
import H21 from './Connex logo.png'
import H3 from './H3.png'
import H4 from './H4.png'
import H5 from './H5.png'
import H6 from './H6.png'
import H7 from './H7.jpeg'
import H8 from './H8.jpg'
import H9 from './H9.png'
import HH11 from './HH1.jpg'
import L1 from './1L.webp'
import L10 from './10L.webp'
import L11 from './11L.jpg'
import L12 from './12L.jpg'
import L13 from './13L.jpg'
import L14 from './14L.webp'
import L15 from './15L.png'
import L16 from './16L.jpg'
import L17 from './L17.png'
import L18 from './18L.jpeg'
import L2 from './2L.webp'
import L3 from './3L.jpg'
import L4 from './4L.jpg'
import L5 from './5L.webp'
import L6 from './6L.webp'
import L7 from './7L.jpg'
import L9 from './9L.jpg'
import MITLogo from './MIT Logo.png'
import a from './6.png'
import admin from './admin.png'
import email from './email.png'
import expo from './Expo.png'
import facebook_icon from './facebook_icon.png'
import linkedin_icon from './linkedin_icon.png'
import p14 from './14.jpeg'
import phone from './phone.png'
import td from './td.png'
import td10 from './8 - Sandali Edirisinghe.jpeg'
import td11 from './9 - Sasanka Wakista.jpeg'
import td12 from './10 - Ramesha Veruni.jpg'
import td13 from './13 - Dinith Devinda.jpg'
import td14 from './14 - Nethuni Rajapakse.jpg'
import td15 from './15 - PRAVEEN ACHINTHA.jpg'
import td16 from './mishar.jpeg'
import td2 from './td2.png'
import td3 from './1.jpg'
import td4 from './2.jpg'
import td5 from './3.jpeg'
import td6 from './2 - Naethree Premnath.jpeg'
import td7 from './3 - Kobishanth Kumaravel.jpg'
import td8 from './6 - Rasini Ranaweera.jpg'
import td9 from './7 - Dulmi Wijerathna.jpeg'
import twitter_icon from './twitter_icon.png'
import unilogo from './unilogo.png'
import up from './up.png'

export const  assest = {
    expo,MITLogo,email,phone,facebook_icon,twitter_icon,linkedin_icon,td,H1,H2,H3,td2,up,admin,H5,H4,H6,H7,H8,H9,H10,H11,unilogo,HH11,
    L1,L2,L3,L4,L5,L6,L7,L9,L10,L11,L12,L13,L14,L15,a,p14,L16,L18,L17,td3,td4,td5,td6,td7,td8,td9,td10,td11,td12,td13,td14,td15,td16,H20,H21
}

